import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormikProps } from 'formik';
import { cleanObj } from '../../../../../shared/utils/objects';
import { ToastSwal } from '../../../../components/general/toastSwals/toastSwal';
import { ISelect } from '../../../../../shared/types/shared';
import { CasesGeneralInformation } from '../../../../../shared/types/modules/cases-general-information';
import {
    asyncCreateCasesGeneralInformation,
    asyncGetCasesGeneralInformation,
    asyncUpdateCasesGeneralInformation,
} from '../../../../../services/cases-general-information.service';
import {
    CASES_GENERAL_INFORMATION,
    CASES_GENERAL_INFORMATION_DETAIL,
} from '../../../../../routes/paths';

export const useCasesGeneralInformationForm = () => {
    const navigate = useNavigate();
    const { idCasesGeneralInformation } = useParams();
    const { idAccount } = useParams();
    const [casesGeneralInformation, setCasesGeneralInformation] =
        useState<CasesGeneralInformation>();
    const [loading, setLoading] = useState(false);
    const [formikCasesGeneralInformation, setFormikCasesGeneralInformation] =
        useState<FormikProps<CasesGeneralInformation>>();

    const isValidForm = formikCasesGeneralInformation?.isValid;

    const handleSubmit = async () => {
        await formikCasesGeneralInformation?.submitForm();

        if (!isValidForm) return;

        setLoading(true);

        const data: CasesGeneralInformation =
            cleanObj(formikCasesGeneralInformation?.values) || {};
        data.account = casesGeneralInformation?.account?.id || idAccount;

        let res: CasesGeneralInformation | undefined = undefined;

        try {
            if (casesGeneralInformation && casesGeneralInformation.id)
                res = await asyncUpdateCasesGeneralInformation(
                    casesGeneralInformation.id,
                    data
                );
            else res = await asyncCreateCasesGeneralInformation(data);
        } catch (error) {}

        if (res) {
            ToastSwal.fire({
                text: `¡Felicidades! El caso de información general se ${
                    casesGeneralInformation && casesGeneralInformation.id
                        ? 'actualizo'
                        : 'creó'
                } satisfactoriamente con ID: ${res.id}`,
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
            navigate(`${CASES_GENERAL_INFORMATION_DETAIL}/${res.id}`);
        } else {
            ToastSwal.fire({
                text: `Lo sentimos, no se pudo ${
                    casesGeneralInformation && casesGeneralInformation.id
                        ? 'actualizar'
                        : 'crear'
                } el caso. Por favor, asegúrate de diligenciar los datos correctamente e intenta nuevamente más tarde.`,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
    };

    const handleClean = () => {
        formikCasesGeneralInformation?.resetForm();
    };

    useEffect(() => {
        if (Boolean(idCasesGeneralInformation?.trim())) {
            setLoading(true);
            asyncGetCasesGeneralInformation(idCasesGeneralInformation?.trim())
                .then((casesGeneralInformation) => {
                    if (!casesGeneralInformation || !casesGeneralInformation.id)
                        navigate(CASES_GENERAL_INFORMATION);

                    [casesGeneralInformation].forEach((item: any) => {
                        if (item)
                            Object.keys(item).forEach((key) => {
                                if (item?.[key] && (item?.[key] as ISelect)?.id)
                                    item[key] = (
                                        item[key] as ISelect
                                    )?.id.toString();
                            });
                    });

                    setCasesGeneralInformation(casesGeneralInformation);
                })
                .finally(() => setLoading(false));
        }
    }, [idCasesGeneralInformation]);

    return {
        casesGeneralInformation,
        idAccount,
        loading,
        isValidForm,
        handleSubmit,
        handleClean,
        formikCasesGeneralInformation,
        setFormikCasesGeneralInformation,
    };
};
